(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.types = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DISPLAY_OPTIONS = void 0;
  let DISPLAY_OPTIONS;
  /** template literal type: allows string literals to be used for display options */

  _exports.DISPLAY_OPTIONS = DISPLAY_OPTIONS;

  (function (DISPLAY_OPTIONS) {
    DISPLAY_OPTIONS["immediate"] = "immediate";
    DISPLAY_OPTIONS["deferred"] = "deferred";
  })(DISPLAY_OPTIONS || (_exports.DISPLAY_OPTIONS = DISPLAY_OPTIONS = {}));
});